import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';  // Asegúrate de importar los servicios necesarios
import { TranslocoService } from '@ngneat/transloco';  // Suponiendo que usas Transloco
import { ProfileService } from './profile/profile.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  public currentLang: string | null = null;
  private idiomaCambiado = new Subject<void>();

  constructor(
    private languageService: LanguageService,
    private translocoService: TranslocoService,
    private profileService: ProfileService
  ) { }

  onIdiomaCambiado(): Observable<void> {
    return this.idiomaCambiado.asObservable();
  }

  changeLanguage(language: any, profileData: any) {
    this.currentLang = language.text.toLowerCase();
    this.languageService
      .getLanguageContent(language.id)
      .subscribe(contentJson => {
        const langCode = language.text.toLowerCase();
        this.translocoService.setTranslation(contentJson);
        const availableLangs = this.translocoService.getAvailableLangs();

        if (!availableLangs.includes(langCode)) 
          this.translocoService.setAvailableLangs([...availableLangs, langCode]);
      });
    if (profileData.name && profileData.languageId != language.id) {
      profileData.languageId = language.id;
      this.profileService.updateProfile(profileData);  
    }
    this.idiomaCambiado.next();
  }
}
